import ProfileCard from 'components/ProfileCard';
import { FormEvent } from 'react';
import { user } from './data';

const LogedIn = () => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };
  return <ProfileCard {...user} handleSubmit={handleSubmit} />;
};

export default LogedIn;
